<template>
    <div>
        <div class="documents-progess-section f-14 text-left d-flex align-items-center mb-2"
            v-for="item in visibleInspectionBanners" :key="`inspection-status-${item.id}`">
            <div class="w-75">
                <template v-if="item.status === 'Failed'">
                    {{ $t('dotInspections.aiFailed') }}{{ item.desc ? `: ${item.desc}` : '' }}.
                </template>
                <template v-else>
                    {{ $t('dotInspections.aiProcessing') }}
                </template>
            </div>
            <p v-if="item.status === 'Failed'" class="mb-0 text-primary cursor-pointer f-14 ml-auto"
                @click="dismissInspectionTask(item)">{{ $t('dotInspections.dismiss') }}</p>
        </div>
        <p v-if="inspectionBanners.length > 2" class="my-2 text-primary cursor-pointer f-14 text-center"
            @click="showAllInspectionBanners = !showAllInspectionBanners">
            {{ showAllInspectionBanners ? $t('dotInspections.showLess') : $t('dotInspections.showMore', {
                count:
                    inspectionBanners.length - 2
            }) }}
        </p>
        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h2 class="text-left mb-0">{{ $t('dotInspections.title') }}</h2>
            <div class="d-flex justify-content-between justify-content-sm-center flex-wrap" v-if="allowAddRecord">
                <b-button class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                    variant="primary" @click="allowAddInspection = true">
                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white">{{ $t('dotInspections.addInspection') }}</p>
                </b-button>
                <b-button @click="showDotInspectionAIModal()"
                    class="d-flex f-14 justify-content-center align-items-center mr-1 my-1 w-fit-content"
                    variant="outline-primary">
                    <p class="mb-0">{{ $t('dotInspections.importWithAi') }}</p>
                </b-button>
            </div>
        </div>
        <div class="data-table team-data-table bg-white rounded table-custom-border">
            <div class="bg-white pt-3 pt-sm-4 rounded">
                <div class="table_row">
                    <div class="filter-box" v-if="isTableMounted">
                        <div class="d-flex mb-4 px-3 px-sm-4">
                            <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                <b-input-group class="username-input-field">
                                    <b-form-input type="text" :placeholder="$t('safetyShared.search')"
                                        v-model="filterFields.search" class="unit f-12"
                                        @keyup.enter="getDotInspectionData()"></b-form-input>
                                    <b-input-group-append>
                                        <b-button variant="primary" @click="getDotInspectionData()">
                                            <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap">
                                <div class="position-relative">
                                    <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                                        {{ activeFiltersCount }}
                                    </div>
                                    <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                                        <div class="d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="lucide lucide-sliders-horizontal w-4 h-4" data-id="element-964">
                                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                                <line x1="16" x2="16" y1="18" y2="22"></line>
                                            </svg>
                                            <p class="mb-0 ml-2">{{ $t('safetyShared.filters') }}</p>
                                        </div>
                                    </button>
                                </div>
                                <div class="table-columns-section ml-2 mt-0" @click="showColumns = true">
                                    <button class="btn btn-table-columns-section">
                                        <div class="d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="lucide lucide-columns2 w-4 h-4" data-id="element-961">
                                                <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                                                <path d="M12 3v18"></path>
                                            </svg>
                                            <p class="mb-0 ml-2">{{ $t('safetyShared.columns') }}</p>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 180px); overflow: hidden;">
                        <b-skeleton-table :rows="17" :columns="7"
                            :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                    </div>
                    <b-table v-else class="mt-2" responsive :fields="visibleFields" :items="items" hover
                        :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                        :no-local-sorting="true" :busy.sync="isBusy" :sticky-header="'calc(100vh - 273px)'"
                        :show-empty="emptyTable">
                        <template #cell(record_no)="data">
                            <p class="mb-0 cursor-pointer text_primary mb-0"
                                @click="inspectionID = data.item.id; pendingTab = 0" v-if="allowViewRecord">{{ data.value }}
                            </p>
                            <p class="mb-0" v-else>{{ data.value }}</p>
                        </template>
                        <template #cell(no_of_violations)="data">
                            <p class="mb-0" :class="data.value > 0 ? 'text-danger' : ''">{{ data.value }}</p>
                        </template>
                        <template #cell(dataq_section)="data">
                            <span>{{ data.value ? $t('safetyShared.yes') : $t('safetyShared.no') }}</span>
                        </template>
                        <template #cell(status)="data">
                            <b-button class="btn f-14 pe-none d-flex justify-content-center align-items-center"
                                :variant="data.item.status === 'New' ? 'warning-status' : data.item.status === 'Urgent' ? 'danger-status' : data.item.status === 'Open' ? 'success-status' : 'secondary-status'">
                                <p class="mb-0">{{ data.value }}</p>
                            </b-button>
                        </template>
                        <template #cell(source)="data">
                            <svg v-if="data.value === 'bot'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.07751 18.9975V15.5368H6.53822" stroke="#2D69F6" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M18.8442 8.34855C19.7053 12.9277 16.9031 17.4673 12.328 18.6933C8.82635 19.6315 5.25353 18.3694 3.07751 15.7545"
                                    stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M1.15502 11.6536C0.293936 7.07442 3.09617 2.53472 7.67127 1.30883C11.1727 0.370634 14.7452 1.63251 16.9213 4.24705"
                                    stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.9219 1V4.46071H13.4612" stroke="#2D69F6" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M5.93818 10.4693C5.4485 10.3842 5.4485 9.6812 5.93818 9.59601C7.71219 9.28739 9.12316 7.93616 9.50822 6.17717L9.53773 6.04233C9.64368 5.55838 10.3328 5.55536 10.4429 6.03837L10.4788 6.1955C10.8781 7.94621 12.2894 9.28601 14.0585 9.59378C14.5506 9.67942 14.5506 10.3859 14.0585 10.4716C12.2894 10.7793 10.8781 12.1192 10.4788 13.8698L10.4429 14.027C10.3328 14.51 9.64368 14.507 9.53773 14.023L9.50822 13.8882C9.12316 12.1292 7.71219 10.778 5.93818 10.4693Z"
                                    stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg v-else-if="data.value === 'driver'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                    :stroke="data.item.document_status === 'approved' ? '#2CCE89' : data.item.document_status === 'in_review' ? '#FFC800' : '#FF0000'"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M10.0004 11.3825C11.9122 11.3825 13.462 9.83266 13.462 7.92091C13.462 6.00916 11.9122 4.45937 10.0004 4.45937C8.08867 4.45937 6.53888 6.00916 6.53888 7.92091C6.53888 9.83266 8.08867 11.3825 10.0004 11.3825Z"
                                    :stroke="data.item.document_status === 'approved' ? '#2CCE89' : data.item.document_status === 'in_review' ? '#FFC800' : '#FF0000'"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M4.08673 16.7876C4.7046 15.7734 5.57299 14.9352 6.60841 14.3536C7.64382 13.7719 8.81144 13.4664 9.99904 13.4664C11.1866 13.4664 12.3543 13.7719 13.3897 14.3536C14.4251 14.9352 15.2934 15.7734 15.9114 16.7876"
                                    :stroke="data.item.document_status === 'approved' ? '#2CCE89' : data.item.document_status === 'in_review' ? '#FFC800' : '#FF0000'"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div v-else>-</div>

                        </template>
                        <template #cell(last_note)="data">
                            <v-app v-if="data.value" class="d-contents align-items-center">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <span
                                            class="w-fit-content item-description text_primary text-left maxw-200px cursor-pointer"
                                            @click.stop="editNote(data.item)" v-on="on" v-bind="attrs">{{
                                                htmlToPlainText(data.value) }}</span>
                                    </template>
                                    <div class="note-tooltip-content">{{ htmlToPlainText(data.value) }}</div>
                                </v-tooltip>
                            </v-app>
                            <span v-else class="d-flex text_primary cursor-pointer" @click.stop="editNote(data.item)">-
                            </span>
                        </template>
                    </b-table>
                    <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                        <div class="d-flex align-items-center flex-wrap">
                            <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                <b-form-select v-model="perPage" :options="pageOptions" />
                            </div>
                            <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                            <div class="pagination">
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                                    aria-controls="my-table"></b-pagination>
                            </div>
                        </div>
                    </div>
                    <ImportInspectionWithAI :title="$t('dotInspections.importWithAi')"
                        @extractionQueued="onExtractionQueued" />
                    <AddInspection @close="allowAddInspection = false" :allowAddInspection="allowAddInspection"
                        @inspectionAdded="getDotInspectionNewData($event)" />
                    <EditInspection :initialTab="pendingTab" :inspectionID="inspectionID"
                        @resetEditInspection="inspectionID = null" @inspectionUpdated="getDotInspectionData()" />
                    <TableColumns :showColumns="showColumns" :fields="fields"
                        @getUpdatedFieldsList="getUpdatedFieldsList($event)" @updateFields="updateFields($event)"
                        @resetTableFields="resetTableFields()" @resetData="showColumns = false" />
                    <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
                        :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
                        <template #modal-header="{ close }">
                            <h5 class="modal-title">
                                {{ $t('safetyShared.filters') }}
                            </h5>
                            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                                Close Modal
                            </b-button>
                        </template>
                        <div class="body">
                            <b-form-group :label="$t('dotInspections.filterLevel')"
                                class="text-left select_arrow label mb-3">
                                <b-form-select v-model="filterFields.level" class="input f-12" :options="[
                                    {
                                        value: '',
                                        text: '',
                                    },
                                    {
                                        value: 'I',
                                        text: '|'
                                    },
                                    {
                                        value: 'II',
                                        text: '||'
                                    },
                                    {
                                        value: 'III',
                                        text: '|||'
                                    }

                                ]" @change="getDotInspectionData()"></b-form-select>
                            </b-form-group>
                            <b-form-group :label="$t('dotInspections.filterVio')" class="text-left select_arrow label mb-3">
                                <b-form-select v-model="filterFields.violations" type="text" class="input f-12"
                                    :options="yesNoOptions" @change="getDotInspectionData()"></b-form-select>
                            </b-form-group>
                            <b-form-group :label="$t('dotInspections.filterDataQ')"
                                class="text-left select_arrow label mb-3">
                                <b-form-select v-model="filterFields.dataq_section" type="text" class="input f-12"
                                    :options="yesNoOptions" @change="getDotInspectionData()"></b-form-select>
                            </b-form-group>
                            <b-form-group :label="$t('dotInspections.filterOos')" class="text-left select_arrow label mb-3">
                                <b-form-select v-model="filterFields.oos_status" type="text" class="input f-12"
                                    :options="yesNoOptions" @change="getDotInspectionData()"></b-form-select>
                            </b-form-group>
                            <b-form-group :label="$t('dotInspections.filterStatus')"
                                class="text-left select_arrow label mb-3">
                                <b-form-select v-model="filterFields.status" type="text" class="input f-12"
                                    :options="statusFilterOptions" @change="getDotInspectionData()"></b-form-select>
                            </b-form-group>
                            <b-form-group :label="$t('teamPage.filterDivision')" class="text-left w-equipment-box">
                                <v-select multiple :options="allDivisions" class="f-12" :reduce="(option) => option.id"
                                    v-model="filterFields.division" @input="getDotInspectionData()" />
                            </b-form-group>
                        </div>
                        <template #modal-footer="">
                            <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                                <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                                    @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('safetyShared.reset')
                                    }}</b-button>
                                <b-button class="mx-0 h-40px w-100px m-0 m-0" block
                                    @click="$bvModal.hide('modal-filter')">{{ $t('safetyShared.close') }}</b-button>
                            </div>
                        </template>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AddInspection from './AddInspection.vue';
import * as moment from "moment-timezone";
import EditInspection from './EditInspection.vue';
import ImportInspectionWithAI from './ImportInspectionWithAI.vue';
import TableColumns from "@/components/Shared/TableColumns.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    name: "DotInspections",
    components: { TableColumns, AddInspection, EditInspection, ImportInspectionWithAI, vSelect },
    data() {
        return {
            showColumns: false,
            items: [],
            currentPage: 1,
            pendingTab: 0,
            allowAddInspection: false,
            inspectionID: null,
            rows: 0,
            perPage: 10,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            emptyTable: false,
            sortBy: undefined,
            sortDesc: undefined,
            isBusy: false,
            isTableMounted: false,
            positionText: "",
            fields: [],
            filterFields: {
                search: '',
                level: '',
                no_of_violations: '',
                dataq_section: '',
                oos_status: '',
                status: '',
                division: []
            },
            inspectionBanners: [],
            showAllInspectionBanners: false,
        }
    },
    computed: {
        ...mapGetters(['rolePermissions', 'userPreferences', 'user', 'divisions', 'company']),
        getAICredits() {
            return this.company[0]?.ai_credits || 0
        },
        yesNoOptions() {
            return [
                { value: '', text: '' },
                { value: 'True', text: this.$t('safetyShared.yes') },
                { value: 'False', text: this.$t('safetyShared.no') },
            ];
        },
        statusFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'New', text: this.$t('safetyShared.statusNew') },
                { value: 'Open', text: this.$t('safetyShared.statusOpen') },
                { value: 'Closed', text: this.$t('safetyShared.statusClosed') },
                { value: 'Urgent', text: this.$t('safetyShared.statusUrgent') },
            ];
        },
        allowViewRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][0].allow
        },
        allowAddRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][2].allow
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (key === 'division') {
                    return count + (this.filterFields.division.length > 0 ? 1 : 0);
                }
                else if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
        visibleFields() {
            return this.fields.filter(field => field?.visible)
        },
        visibleInspectionBanners() {
            return this.showAllInspectionBanners
                ? this.inspectionBanners
                : this.inspectionBanners.slice(0, 2);
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    watch: {
        userPreferences: {
            async handler() {
                if (this.userPreferences) {
                    this.fields = this.userPreferences['Safety Inspection'].sort((a, b) => a.display_order - b.display_order).map((col) => {
                        return { ...col, thClass: 'font-table-weight-bold', ...col.key === 'selected' ? { thStyle: { minWidth: "20px", width: "20px" } } : {} }
                    })
                }
            },
            immediate: true
        },
        perPage: {
            async handler() {
                await this.getDotInspectionData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getDotInspectionData();
            },
        },
        sortBy: {
            async handler() {
                await this.getDotInspectionData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getDotInspectionData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
    },
    methods: {
        ...mapActions(['getAllDotInspections', 'updateUserPreferences', 'deleteUserPreferences', 'setLoader', 'getInspectionExtractList', 'dismissInspectionExtractTask', 'setNotification']),
        showDotInspectionAIModal() {
            if (this.getAICredits > 0) {
                this.$bvModal.show('modal-import-inspection-ai')
            }
            else {
                this.setNotification({
                    msg: this.$t('recordsAndTotal.noAICredits'),
                    type: "error",
                    color: "red",
                });
            }
        },
        async onExtractionQueued() {
            await this.getDotInspectionData();
            await this.getInspectionUploadStatus();
        },
        async getInspectionUploadStatus() {
            try {
                const data = await this.getInspectionExtractList();
                const list = Array.isArray(data) ? data : (data ? [data] : []);
                const activeStatuses = ['Queued', 'Uploading', 'Extracting', 'In Progress', 'Failed'];
                this.inspectionBanners = list.filter(item => activeStatuses.includes(item.status));
            } catch (e) {
                console.log(e);
            }
        },
        async dismissInspectionTask(item) {
            try {
                await this.dismissInspectionExtractTask({
                    id: item.id,
                    payload: { dismissed: true },
                });
                this.inspectionBanners = this.inspectionBanners.filter(i => i.id !== item.id);
            } catch (e) {
                console.log(e);
            }
        },
        editNote(item) {
            this.pendingTab = 3;
            this.inspectionID = item.id;
        },
        htmlToPlainText(htmlString) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            return tempDiv.textContent || tempDiv.innerText || '';
        },
        async getUpdatedFieldsList(updatedFields) {
            this.fields = updatedFields
            try {
                const updatedOrderList = updatedFields.map((item, index) => {
                    return { ...item, display_order: index + 1 }
                })
                await this.updateUserPreferences(
                    {
                        "columns": updatedOrderList
                    })
            }
            catch (e) {
                console.log(e)
            }
        },
        async getDotInspectionNewData(id) {
            await this.getDotInspectionData()
            if (id) this.inspectionID = id
            this.allowAddInspection = false
        },
        async updateFields(updatedFields) {
            this.fields = updatedFields
            this.filterFields = {
                search: '',
                type: '',
                tags: [],
                status: '',
                division: []
            }
            try {
                await this.updateUserPreferences({
                    "columns": updatedFields
                })
                await this.getDotInspectionData()
            }
            catch (e) {
                console.log(e)
            }
        },
        async getDotInspectionData() {
            try {
                this.items = []
                this.isBusy = true
                let url = ""
                let tags = ""
                Object.keys(this.filterFields).map((key) => {
                    if (this.filterFields[key] && key != 'division') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                    else if (key === "division" && this.filterFields[key].length > 0) {
                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=record_no&sort_order=desc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getAllDotInspections(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('safetyShared.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('safetyShared.emptyPosition')
                }
                data.records.map((item) => {
                    this.items.push({
                        id: item.id,
                        driver: item.driver_name,
                        record_no: item.record_no,
                        vehicle: item.vehicle_name ? item.vehicle_name : '-',
                        trailer: item.trailer_name ? item.trailer_name : '-',
                        level: item.level ? item.level : '-',
                        date: item.date ? moment(item.date).format("ll") : '-',
                        no_of_violations: item.no_of_violations ? item.no_of_violations : '-',
                        total_points: item.total_points ? item.total_points : '-',
                        report_number: item.report_number ? item.report_number : '-',
                        state: item.state_name ? item.state_name : '-',
                        status: item.status,
                        no_of_true_oos: item.no_of_true_oos ? item.no_of_true_oos : '-',
                        division: item.division ? item.division_read.division : '-',
                        last_note: item.last_note ? item.last_note.note : '-',
                        source: item.source,
                        dataq_section: item.dataq_section
                    });
                })

                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }

        },
        async resetTableFields() {
            try {
                this.setLoader(true)
                await this.deleteUserPreferences(`Safety Inspection/`)
                this.showColumns = false
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                level: '',
                no_of_violations: '',
                dataq_section: '',
                oos_status: '',
                status: '',
                division: []
            },
                await this.getDotInspectionData();
        }
    },
    async mounted() {
        await this.getInspectionUploadStatus();
    },
}
</script>